import { FileCode2, Download } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/ui-kit";

const FILES = [
  ["01_850_replenishment_XD2.edi", "1. Import EDI", "850 replenishment PO DEMO-RPL-0001 to XD2 (10 pallets RUMA + 10 RUMB). Then ship it from Replenishment."],
  ["02_861_receiving_advice_XD2.edi", "2. Import EDI", "861 receipt for DEMO-RPL-0001: adds the stock at XD2"],
  ["03_sap_amazon_orders.csv", "3. Order Import > SAP file", "Two Amazon orders (DEMO-AMZ-0001 / 0002) that auto-release 940s"],
  ["03b_coupa_po_export.csv", "3 (alt). Order Import > Coupa", "Same Amazon orders as a Coupa PO export (use instead of the SAP file)"],
  ["03c_coupa_cxml_order_request.xml", "Reference", "Example Coupa cXML OrderRequest (set the shared secret first)"],
  ["997", "4. Import EDI", "Group O 997 accepting your latest 940 (built live; download once per 940)"],
  ["05_945_shipping_advice_full.edi", "5. Import EDI", "945 for DEMO-AMZ-0001: shipped in full"],
  ["06_945_shipping_advice_short.edi", "6. Import EDI", "945 for DEMO-AMZ-0002: short shipped (1 of 2 pallets)"],
  ["ref_940_warehouse_shipping_order.edi", "Reference", "Example of the 940 we send to Group O"],
  ["ref_997_our_ack_of_850.edi", "Reference", "Example of the 997 we send back for an 850"],
];

const get997 = async () => {
  try {
    const r = await api.get("/samples/997", { responseType: "blob" });
    const name = (r.headers["content-disposition"] || "").split("filename=")[1] || "04_997.edi";
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: name });
    a.click();
  } catch (e) {
    toast.error(e.response?.status === 404 ? "No 940 is waiting for a 997 - import the SAP order sample first" : errMsg(e));
  }
};

export const SamplesPanel = () => (
  <Panel title="Sample EDI files (demo & testing)" testId="settings-samples-panel">
    <ul className="divide-y divide-slate-800">
      {FILES.map(([file, step, desc]) => (
        <li key={file} className="flex items-center gap-4 px-5 py-3">
          <FileCode2 className="h-5 w-5 shrink-0 text-amber-300" />
          <div className="min-w-0 flex-1">
            <div className="truncate font-mono text-sm text-slate-100">{file === "997" ? "04_997_accepting_940.edi" : file}</div>
            <div className="text-xs text-slate-500"><span className="text-slate-300">{step}</span> · {desc}</div>
          </div>
          {file === "997" ? (
            <button onClick={get997} className="rounded-sm p-2 text-slate-400 transition-colors hover:bg-slate-800 hover:text-slate-100" aria-label="Download 997" data-testid="sample-download-997"><Download className="h-4 w-4" /></button>
          ) : (
            <a href={`/docs/samples/${file}`} download className="rounded-sm p-2 text-slate-400 transition-colors hover:bg-slate-800 hover:text-slate-100" aria-label={`Download ${file}`} data-testid={`sample-download-${file.split(".")[0]}`}><Download className="h-4 w-4" /></a>
          )}
        </li>
      ))}
    </ul>
  </Panel>
);
